import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobal } from 'store/global/reducer';
import Popup from 'components/popup/popup';
import { Grid } from '@material-ui/core';
import MsgBox from 'components/MsgBox/MsgBox';
import UploadModal from 'components/uploadFile/UploadModal';
import { SAVE_CTA_DETAIL } from 'store/key';
import useDialog from 'components/ConfirmDialog/useDialog';
import { CTA_SUBMITTED, CTA_REQUIRED } from 'utility/frontendMessage';
const UploadCTAPopup = (props) => {
    const { openPopup } = props;
    const dispatch = useDispatch();
    const modalRefID = useSelector((state) => state.global.modalRefID);
    const defaultFromData = {
        effectiveDate: {
            id: '0',
            value: null,
            label: 'Effective Date',
            name: 'effectiveDate',
            type: 'date',
            validators: ['isRequired'],
        },
        upload: {
            id: '2',
            value: [],
            type: 'upload',
            downloadType: 'cta',
        },
    };
    const [formData, setFormData] = useState([defaultFromData]);
    const [warningMsg, setWarningMsg] = useState(null);
    const [forceShowError, setForceShowError] = useState(false);

    const showDialog = useDialog();

    const checkValid = () => {
        if (!formData.length) {
            return showDialog({
                description: CTA_REQUIRED,
                disableCancelButton: true,
            });
        };

        setForceShowError(true);
        let isUploadedFile = true;
        let isValid = true;
        const copyFormData = [...formData];

        for (let i of copyFormData) {
            if (!i.upload.uploadTempId) {
                i.upload.error = true;
                isUploadedFile = false;
            }
            if (!i.effectiveDate.value) {
                isValid = false;
            }
        }

        if (!isUploadedFile || !isValid) {
            setFormData(copyFormData);
        };

        return isUploadedFile && isValid;
    };

    const onSubmit = () => {
        if (checkValid()) {
            let tempCta = [];
            formData.forEach((data) => {
                tempCta.push({
                    effectiveDtm: new Date(data.effectiveDate.value),
                    uploadTempId: data.upload.uploadTempId,
                });
            });
            dispatch({
                type: SAVE_CTA_DETAIL,
                payload: {
                    data: tempCta,
                    id: modalRefID,
                    callback: () => {
                        showDialog({
                            description: CTA_SUBMITTED,
                            disableCancelButton: true,
                        });
                        onClose();
                    },
                },
            });
        };
    };

    const onClose = () => {
        dispatch(
            setGlobal({
                openUploadCTAPopup: false,
            }),
        );
    };
    const onRemove = (rowIndex) => {
        const copyFormData = [...formData];
        copyFormData[rowIndex].upload.value = [];
        copyFormData[rowIndex].upload.uploadTempId = null;

        setFormData(copyFormData);
    };
    return (
        <>
            {warningMsg ? (
                <MsgBox
                    type={warningMsg.type}
                    message={warningMsg.message}
                    footerActions={warningMsg.footerActions}
                    title={warningMsg.title}
                    closePopup={() => setWarningMsg(null)}
                />
            ) : null}
            <Popup
                height="70%"
                width="50%"
                title="Upload CTA / CTA Amendment"
                open={openPopup}
                footerActions={[
                    { label: 'Cancel', color: 'default', clicked: onClose },
                    { label: 'Confirm', clicked: onSubmit },
                ]}
                closePopup={onClose}
            >
                <Grid container alignItems="flex-start">
                    <UploadModal
                        groupType="CTA"
                        formData={formData}
                        setFormData={setFormData}
                        setWarningMsg={setWarningMsg}
                        defaultFormData={defaultFromData}
                        title="Upload CTA / CTA Amendment"
                        forceErrorDisplay={forceShowError}
                        enableRemove={true}
                        onRemove={onRemove}
                    />
                </Grid>
            </Popup>
        </>
    );
};

export default UploadCTAPopup;
